import { useCallback } from "react";
import type { FeatureLike } from "ol/Feature";
import { MileageStyle } from "../../pages/MapPage/MileageStyleFunction";
import { useBoundaries } from "../../context/boundary";

export function useMileageStyle(
  mileageTheme: any,
  year: number,
  opacity: number,
  selectedBoundaryId?: string,
) {
  const { boundaries } = useBoundaries();

  return useCallback(
    (feature: FeatureLike, resolution: number) =>
      MileageStyle(
        feature,
        resolution,
        mileageTheme,
        year,
        opacity,
        selectedBoundaryId,
      ),
    [mileageTheme, year, opacity, selectedBoundaryId, boundaries],
  );
}
